module.exports = __webpack_public_path__ + "img/bangladeshi-taka-sign.0f632b33.svg";